var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartyFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2001 0.600098H0.600098V17.4001H10.2001V0.600098Z",
    fill: "#9A9AC0",
    stroke: "#030362",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2001 13.0679H0.600098V17.2679H10.2001V13.0679Z",
    stroke: "#030362",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4001 0.600098H0.600098V17.4001H5.4001V0.600098Z",
    stroke: "#030362",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2001 4.66797H0.600098V8.86797H10.2001V4.66797Z",
    stroke: "#030362",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2219 8.86816H17.4002V17.4002H10.2002V8.86816",
    stroke: "#030362",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9841 8.86816H17.4001V17.4002H0.600098V8.86816",
    stroke: "#030362",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_1665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyFilledIcon);
export default __webpack_public_path__ + "static/media/party-filled-icon.52ff7808df33941351bf770b5c1b0fed.svg";
export { ForwardRef as ReactComponent };